import axios from '@/api/axios';

const getList = (
  companyId,
  {filters = {}, pagination: {limit = 10, offset = 0}, sort: {sort_field, sort_order}}
) =>
  axios.post(`/roadmap_manual/company/${companyId}/list`, filters || {}, {
    params: {
      limit,
      offset,
      sort_field,
      sort_order,
    },
  });

const getTasksStat = (roadmapId, sourceCode) =>
  axios.get(`/roadmap_manual/${roadmapId}/tasks_stat`, {
    params: {source_code: sourceCode},
  });

const createRoadmap = (data) => axios.post('/roadmap_manual', data);

const createGroupRoadmaps = (data) => axios.post('/roadmap_manual/group', data);

const proposeRoadmap = (data) => axios.post('/roadmap_manual/propose', data);

const getProposeAvailability = (companyId) =>
  axios.get('/roadmap_manual/propose/available', {params: {company_id: companyId}});

const getDirectSupervisors = (params) => axios.get('/roadmap_manual/direct_supervisor', {params});

const getHeader = (roadmapId) => axios.get(`/roadmap_manual/${roadmapId}`);

const updateHeader = (roadmapId, data) => axios.put(`/roadmap_manual/${roadmapId}`, data);

const deleteRoadmap = (roadmapId) => axios.delete(`/roadmap_manual/${roadmapId}`);

const changeStatus = (roadmapId, data) => axios.put(`/roadmap_manual/${roadmapId}/status`, data);

const getDecisions = (roadmapId) => axios.get(`/roadmap_manual/${roadmapId}/decisions`);

const getCommonMaterials = (roadmapId) =>
  axios.get(`/roadmap_manual/${roadmapId}/materials/common`);

const getBlockMaterials = (roadmapId) => axios.get(`/roadmap_manual/${roadmapId}/materials/blocks`);

const getSkills = (roadmapId) => axios.get(`/roadmap_manual/${roadmapId}/skills`);

const addMaterials = (roadmapId, materials) =>
  axios.post(
    `/roadmap_manual/${roadmapId}/materials`,
    Array.isArray(materials) ? materials : [materials]
  );

const deleteMaterials = (roadmapId, materialIds) =>
  axios.put(
    `/roadmap_manual/${roadmapId}/materials/delete`,
    Array.isArray(materialIds) ? materialIds : [materialIds]
  );

const updateMaterial = (materialId, data) =>
  axios.put(`/roadmap_manual/materials/${materialId}`, data);

const changeMaterialStatus = (materialId, status) =>
  axios.put(`/roadmap_manual/materials/${materialId}/status`, {status});

const saveMaterialResult = (materialId, data) =>
  axios.put(`/roadmap_manual/materials/${materialId}/result`, data);

const getMaterialComments = (materialId) =>
  axios.get(`/roadmap_manual/materials/${materialId}/comments`);

const addMaterialComment = (materialId, data) =>
  axios.post(`/roadmap_manual/materials/${materialId}/comments`, data);

const getSupervised = ({
  filters = {},
  pagination: {limit = 10, offset = 0},
  sort: {sort_field, sort_order},
}) =>
  axios.post('/roadmap_manual/supervised', filters || {}, {
    params: {
      limit,
      offset,
      sort_field,
      sort_order,
    },
  });

const getSupervisedBadge = (companyId) =>
  axios.get('/roadmap_manual/supervised/badge', {params: {company_id: companyId}});

const getIface = (companyId) =>
  axios.get('/roadmap_manual/iface', {params: {company_id: companyId}});

export default {
  getList,
  getTasksStat,
  createRoadmap,
  createGroupRoadmaps,
  proposeRoadmap,
  getProposeAvailability,
  getDirectSupervisors,
  getHeader,
  updateHeader,
  deleteRoadmap,
  changeStatus,
  getDecisions,
  getCommonMaterials,
  getBlockMaterials,
  getSkills,
  addMaterials,
  deleteMaterials,
  updateMaterial,
  changeMaterialStatus,
  saveMaterialResult,
  getMaterialComments,
  addMaterialComment,
  getSupervised,
  getSupervisedBadge,
  getIface,
};
